import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink } from 'reactstrap';

export default function TabNav({
  aiSupported = false,
  activeTab,
  setActiveTab,
  snIntegrationCheck,
  credentials,
  isConfigured,
  hasBugRisk,
  loading = false
}) {
  const toggleTab = tab => {
    if (activeTab !== tab && !loading) setActiveTab(tab);
  };

  return (
    <>
      <Nav tabs className="nav-pills">
        <NavItem
          data-testid={'overview-tab'}
          className={`${
            activeTab === '1' ? 'bg-branding-gray shadow branding-blue' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '1' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('1');
            }}
          >
            {' '}
            Overview
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'credentials-tab'}
          className={`${activeTab === '2' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'} ${
            credentials ? '' : 'd-none'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '2' ? 'branding-blue' : ''} `}
            onClick={() => {
              toggleTab('2');
            }}
            disabled={!snIntegrationCheck || loading}
          >
            Credentials
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'default-config-tab'}
          className={`${
            activeTab === '3' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '3' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('3');
            }}
            disabled={!snIntegrationCheck || loading}
          >
            {' '}
            Settings
          </NavLink>
        </NavItem>
        {aiSupported && (
          <NavItem
            data-testid={'ai-tab'}
            className={`${
              activeTab === '8' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
            } btn btn-outline-blue mr-3`}
          >
            <NavLink
              className={`${activeTab === '8' ? 'branding-blue' : ''}`}
              onClick={() => {
                toggleTab('8');
              }}
              disabled={!snIntegrationCheck || loading}
            >
              {' '}
              AI Settings
            </NavLink>
          </NavItem>
        )}

        <NavItem
          data-testid={'filtering-tab'}
          className={`${
            activeTab === '4' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '4' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('4');
            }}
            disabled={!snIntegrationCheck || loading}
          >
            {' '}
            Configuration
          </NavLink>
        </NavItem>
        {hasBugRisk ? (
          <NavItem
            data-testid={'risk-tab'}
            className={`${
              activeTab === '5' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
            } btn btn-outline-blue mr-3`}
          >
            <NavLink
              className={`${activeTab === '5' ? 'branding-blue' : ''}`}
              onClick={() => {
                toggleTab('5');
              }}
              disabled={!snIntegrationCheck || loading}
            >
              {' '}
              Risk Score
            </NavLink>
          </NavItem>
        ) : null}
        <NavItem
          data-testid={'history-tab'}
          className={`${
            activeTab === '6' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue`}
        >
          <NavLink
            className={`${activeTab === '6' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('6');
            }}
            disabled={!snIntegrationCheck || loading}
          >
            History
          </NavLink>
        </NavItem>
      </Nav>
    </>
  );
}

TabNav.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  snIntegrationCheck: PropTypes.bool,
  credentials: PropTypes.bool,
  setIsLoading: PropTypes.func,
  setServices: PropTypes.func,
  setBugs: PropTypes.func,
  setPriorityStats: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setVendors: PropTypes.func,
  isLoading: PropTypes.bool,
  vendorId: PropTypes.string,
  isConfigured: PropTypes.bool,
  hasBugRisk: PropTypes.bool,
  aiSupported: PropTypes.bool,
  loading: PropTypes.bool
};
